var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-auto w-full justify-center flex items-center text-3xl text-pink-600 p-4"},[_c('Icon',{attrs:{"icon":"mdi-loading"}}),_c('p',{staticClass:"text-xs font-medium ml-2"},[_vm._v("Идет загрузка пожалуйста подождите")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }